export default __webpack_public_path__ + "static/section3-b60bf93c2dbf0a370827d8dc235c53c6.webp";